
import "../../vendor/default";
import * as web from "./common/web";
import {router} from "./routes";

import "../styles/index.scss";

if (
	"find" in Array.prototype
) {
	run();
} else {
	import("../../vendor/pollyfill").then(() => {
		run();
	});
}

function run() {
	web.init();
	window.flipp.start = start;
}

function start() {
	web.go(router);
}

